/** England and Wales bank holidays, from https://www.gov.uk/bank-holidays.json (2026 and 2027 checked 4 Oct 2026;
 * 2028 worked out from the usual rules: check it against gov.uk once published). Extend yearly: the audit app has a test that fails when the list runs out within a year. */
export const ENGLAND_WALES_BANK_HOLIDAYS: readonly string[] = [
  "2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25", "2026-08-31", "2026-12-25", "2026-12-28",
  "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31", "2027-08-30", "2027-12-27", "2027-12-28",
  "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29", "2028-08-28", "2028-12-25", "2028-12-26",
];

/**
 * The date n working days after `start` (YYYY-MM-DD). The start day itself is day 0,
 * so complete data on a Monday with n = 5 gives the following Monday.
 */
export function addWorkingDays(start: string, n: number, holidays: readonly string[] = ENGLAND_WALES_BANK_HOLIDAYS): string {
  const off = new Set(holidays);
  const d = new Date(`${start}T12:00:00Z`);
  let left = n;
  while (left > 0) {
    d.setUTCDate(d.getUTCDate() + 1);
    const iso = d.toISOString().slice(0, 10);
    const dow = d.getUTCDay();
    if (dow !== 0 && dow !== 6 && !off.has(iso)) left--;
  }
  return d.toISOString().slice(0, 10);
}
